export default __webpack_public_path__ + "static/this-is-new-jira-432f9f1e505e2d66f4e01f03550d5068.png";